import React from "react";
import { Col, Row } from "react-bootstrap";
import ActiveUsers from "../../student_portal/dashboard_Content/activeUsers/ActiveUsers";
import Hotel_ActiveUsersData from "./hotel_activeUsersData/Hotel_ActiveUsersData";
import Hotel_Global_map_buckets from "./hotel_global_map_buckets/Hotel_Global_map_buckets";

function Hotel_Global_map() {
  return (
    <>
      <section className="Global_map">
        <Row>
          <Col lg={12} className="mb-3">
            <Hotel_Global_map_buckets/>
          </Col>
          <Col lg={8} className="mb-3">
            <ActiveUsers />
          </Col>
          <Col lg={4} className="mb-3">
            <Hotel_ActiveUsersData />
          </Col>
        </Row>
      </section>
    </>
  );
}

export default Hotel_Global_map;
